import React, { Component } from 'react'
import DailyTable from './tables/DailyTable.jsx'
import I18n from 'i18n-js'
import '../translations.js'

export default class SmallTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: [],
      total: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    var fields = nextProps.summary.services.filter((element) => element.source === nextProps.tab.id);
    var total = fields.map((element) => {return parseInt(element.value)}).filter(Number).reduce((total, x) => {return total + x;}, 0);
    this.setState({fields, total})
  }

  render() {//this.props.service.price.toFixed(2)
    return (
      <div>
        <h4>{`${this.props.tab.name}: ${this.state.total} ${this.props.tab.resources} ${I18n.t("at")} ${I18n.toCurrency(this.props.service.price)} ${I18n.t("per")} ${this.props.tab.resources.slice(0,-1)}`}</h4>
        <DailyTable
          showDays={this.props.duration.show_days}
          daysBefore={this.props.duration.days_before_show}
          daysAfter={this.props.duration.days_after_show}
          startDate={this.props.duration.start_date}
          tabId={this.props.tab.id}
          maxQuantity={typeof this.props.service.available === "number" ? this.props.service.available : 1000}
          summary={this.props.summary}
          editable={this.props.editable}
          onChange={this.props.tableInputChange}
        />
      </div>
    )
  }
}
